import EmailValidator from 'email-validator';
export default class Email {
  constructor(rawString) {
    this.rawString = rawString;
  }
  static isValid(str) {
    return EmailValidator.validate(str);
  }
  static fromString(str) {
    return Email.isValid(str) ? new Email(str) : undefined;
  }
  static unsafeFromString(str) {
    const result = Email.fromString(str);
    if (result) {
      return result;
    } else {
      throw Error(`String literal ${str} cannot be unsafe cast into type Email.`);
    }
  }
  toString() {
    return this.rawString;
  }
}